import { useState, useRef, useEffect } from "react";
import "./VideoSwipeSlider.css";
import ReactPlayer from "react-player";

const videos = [
  "https://www.youtube.com/embed/NBKKFh-9qh4",
  "https://www.youtube.com/embed/f3bDMV3-Y64",
  "https://www.youtube.com/embed/TgkUpTi8DXY",
];

const VideoSwipeSlider = () => {
  const [current, setCurrent] = useState(0);
  const autoplayRef = useRef<NodeJS.Timeout | null>(null);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % videos.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + videos.length) % videos.length);
  };

  useEffect(() => {
    autoplayRef.current = setInterval(nextSlide, 30000);
    return () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
    };
  }, []);

  return (
    <div className="video-swipe-slider">
      <div
        className="video-track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {videos.map((video, index) => (
          <div className="video-slide" key={index}>
            <ReactPlayer
              url={video}
              width="auto"
              height="350px"
              controls={false}
              className="rounded-circle"
              config={{ youtube: { playerVars: { showinfo: 0, controls: 0 } } }}
            />
          </div>
        ))}
      </div>

      <button className="nav-button prev" onClick={prevSlide}>
      <i className="flaticon-left-arrow"></i>
      </button>
      <button className="nav-button next" onClick={nextSlide}>
      <i className="flaticon-right-arrow"></i>
      </button>
    </div>
  );
};

export default VideoSwipeSlider;
